
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/pricing",
      function () {
        return require("private-next-pages/[ssgParams]/pricing/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/pricing"])
      });
    }
  